// src/utils/inventory/periodUtils.js
import { toISODate, parsePeriodToDate } from "./dateUtils";

export function weekKey(dateObj) {
  const d = new Date(Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()));
  const day = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  const y = d.getUTCFullYear();
  const w = String(weekNo).padStart(2, "0");
  return `${y}-W${w}`;
}

export function groupKeyByPeriod(dateObj, period) {
  if (period === "D") return toISODate(dateObj);
  if (period === "W") return weekKey(dateObj);
  if (period === "M")
    return `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}`;
  if (period === "Y") return `${dateObj.getFullYear()}`;
  return toISODate(dateObj);
}

export function isYearBoundary(periodStr, period) {
  if (period === "Y") return true;
  if (period === "M") return periodStr.endsWith("-01");
  if (period === "W") return periodStr.endsWith("-W01");
  if (period === "D") return periodStr.endsWith("-01-01");
  return false;
}

export function isQuarterBoundary(periodStr, period) {
  if (period === "Y") return false;
  if (period === "M") return /-(01|04|07|10)$/.test(periodStr);
  if (period === "D") return /-(01|04|07|10)-01$/.test(periodStr);
  if (period === "W") {
    const dt = parsePeriodToDate(periodStr);
    if (!dt) return false;
    const month = dt.getMonth() + 1;
    return month === 1 || month === 4 || month === 7 || month === 10;
  }
  return false;
}

export function getYearFromPeriod(periodStr) {
  return periodStr ? String(periodStr).slice(0, 4) : "";
}

export function getQuarterLabel(periodStr, period) {
  if (!periodStr) return "";

  if (period === "M" || period === "D") {
    const m = Number(String(periodStr).slice(5, 7));
    if (!m) return "";
    return `Q${Math.floor((m - 1) / 3) + 1}`;
  }

  if (period === "W") {
    const dt = parsePeriodToDate(periodStr);
    if (!dt) return "";
    const m = dt.getMonth() + 1;
    return `Q${Math.floor((m - 1) / 3) + 1}`;
  }

  return "";
}
